class PredictiveSearch extends HTMLElement {
  static INIT_DELAY = 10;

  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.predictiveSearchDefaultContainer = this.querySelector('#predictive-search-results-container');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.ssReadyInterval = setInterval(() => {
      if (typeof athos !== 'undefined') {
        clearInterval(this.ssReadyInterval);
        
        if (athos.isEnabled()) {
          this.initSSAutocompleteController();
        }
      }
    }, PredictiveSearch.INIT_DELAY);
  }

  disconnectedCallback() {
    clearInterval(this.ssReadyInterval);
  }

  initSSAutocompleteController() {
    this.controllerSettings = {
      id: 'autocomplete',
      selector: '#Search',
      settings: {
        integratedSpellCorrection: true,
        initializeFromUrl: true,
        trending: {
          limit: 5,
          showResults: true,
        }
      },
      globals: {
        suggestions: {
          count: 4,
        },
        pagination: {
          pageSize: 30
        }
      }
    }

    this.athosController = athos.initController('autocomplete', this.controllerSettings);

    this.athosController.init();
    this.athosController.bind();
  }

  async fetchAthosResults(searchTerm) {
    await this.athosController.search({ query: searchTerm });

    const results = [...this.athosController.store.results].slice(0, 3);

    return results;
  }

  async generateAthosProducts(results) {
    const productHandles = results.map(product => {
      const url = product.mappings.core.url;
      const parts = url.split('/');
      const handle = parts[parts.length - 1].split('?')[0];

      return handle;
    });

    const productsMarkup = await athos.fetchProducts(productHandles, 'search-horizontal');

    return productsMarkup;
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    this.predictiveSearchDefaultContainer.classList.add('hidden');
    this.predictiveSearchResults.classList.remove('!hidden');

    if (!searchTerm.length) {
      this.predictiveSearchDefaultContainer.classList.remove('hidden');
      this.predictiveSearchResults.classList.add('!hidden');
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then(async (text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');

        if (athos.isEnabled()) {
          const athosResults = await this.fetchAthosResults(searchTerm);
          const productsContainer = resultsMarkup.querySelector('#search-products-recommendations-list');
          const searchResultsBtn = resultsMarkup.querySelector('[data-search-results-btn]');

          if (athosResults.length > 0) {
            const productCards = await this.generateAthosProducts(athosResults);

            if (productsContainer && productCards.length > 0) {
              productsContainer.replaceChildren();

              productCards.forEach(card => productsContainer.appendChild(card));

              searchResultsBtn.classList.remove('hidden');
            }
          } else {
            searchResultsBtn.classList.add('hidden');
          }
        }

        this.predictiveSearchResults.innerHTML = resultsMarkup.innerHTML;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
